import { render, staticRenderFns } from "./frackOil.vue?vue&type=template&id=8097093a&scoped=true"
import script from "./frackOil.vue?vue&type=script&lang=js"
export * from "./frackOil.vue?vue&type=script&lang=js"
import style0 from "./frackOil.vue?vue&type=style&index=0&id=8097093a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8097093a",
  null
  
)

export default component.exports